import { render } from "./AssessmentResultsLayout.vue?vue&type=template&id=52a90a8e&scoped=true"
import script from "./AssessmentResultsLayout.vue?vue&type=script&lang=js"
export * from "./AssessmentResultsLayout.vue?vue&type=script&lang=js"

import "./AssessmentResultsLayout.vue?vue&type=style&index=0&id=52a90a8e&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a90a8e"]])

export default __exports__